/** @internal */
export const OP_PULL_AFTER_NEXT = "PullAfterNext";
/** @internal */
export const OP_PULL_AFTER_ALL_ENQUEUED = "PullAfterAllEnqueued";
//# sourceMappingURL=channelUpstreamPullStrategy.js.map